import { LABS_CATEGORIES } from './labs-feature-categories';
import { DemoOrders, LossPrevention, PackingRecommendations } from '../../../constants/features';
import { getAutomationWorkflowsSettingsPath } from '../../../routes/constants';

export const FEATURE_RELEASE_TYPE = {
  EARLY_ACCESS: 'early_access',
};

export const CTA_ACTION_PREFIX = 'action:';
export const CTA_ACTIONS = { OPEN_SHIPPY: 'openShippy' };
export const LABS_CTA_ACTION_EVENT = 'labs:ctaAction';

const FEATURES = [
  {
    featureEnum: DemoOrders,
    titleKey: 'demoOrdersTitle',
    descriptionKey: 'demoOrdersDescription',
    confirmationTextKey: 'demoOrdersConfirmationText',
    requiresApproval: false,
    optionalCategory: LABS_CATEGORIES.ORDERS,
    ctaButtonTitleKey: 'demoOrdersCtaButtonTitle',
    ctaRoute: '/orders',
  },
  {
    featureEnum: 'AIAutomationRuleCreator',
    titleKey: 'aiAutomationRuleCreatorTitle',
    descriptionKey: 'aiAutomationRuleCreatorDescription',
    confirmationTextKey: 'aiAutomationRuleCreatorConfirmationText',
    requiresApproval: false,
    optionalCategory: LABS_CATEGORIES.AUTOMATION,
    ctaButtonTitleKey: 'aiAutomationRuleCreatorCtaButtonTitle',
    ctaRoute: '/settings/automationrules',
  },
  {
    featureEnum: 'LotTracking',
    titleKey: 'lotTrackingTitle',
    descriptionKey: 'lotTrackingDescription',
    confirmationTextKey: 'lotTrackingConfirmationText',
    requiresApproval: false,
    optionalCategory: LABS_CATEGORIES.INVENTORY,
    ctaButtonTitleKey: 'lotTrackingCtaButtonTitle',
    ctaRoute: '/products/inventory',
  },
  {
    featureEnum: 'PickListsCustomized',
    titleKey: 'PickListsCustomizedTitle',
    descriptionKey: 'PickListsCustomizedDescription',
    confirmationTextKey: 'PickListsCustomizedConfirmationText',
    requiresApproval: false,
    optionalCategory: LABS_CATEGORIES.INVENTORY,
    ctaButtonTitleKey: 'pickListsCustomizedCtaButtonTitle',
    ctaRoute: '/settings/picklist',
  },
  {
    featureEnum: 'AiHarmonizationCodeGenerator',
    titleKey: 'aiHarmonizationCodeGeneratorTitle',
    descriptionKey: 'aiHarmonizationCodeGeneratorDescription',
    confirmationTextKey: 'aiHarmonizationCodeGeneratorConfirmationText',
    requiresApproval: false,
    optionalCategory: LABS_CATEGORIES.PRODUCTS,
    ctaButtonTitleKey: 'aiHarmonizationCodeGeneratorCtaButtonTitle',
    ctaRoute: '/products',
  },
  {
    featureEnum: 'AiShippyAssistant',
    titleKey: 'aiShippyAssistantTitle',
    descriptionKey: 'aiShippyAssistantDescription',
    confirmationTextKey: 'aiShippyAssistantConfirmationText',
    requiresApproval: false,
    optionalCategory: LABS_CATEGORIES.SUPPORT,
    ctaButtonTitleKey: 'aiShippyAssistantCtaButtonTitle',
    ctaRoute: 'action:openShippy',
  },
  {
    featureEnum: 'AutomationWorkflows',
    titleKey: 'automationWorkflowsTitle',
    descriptionKey: 'automationWorkflowsDescription',
    confirmationTextKey: 'automationWorkflowsConfirmationText',
    requiresApproval: true,
    optionalCategory: LABS_CATEGORIES.AUTOMATION,
    ctaButtonTitleKey: 'automationWorkflowsCtaButtonTitle',
    ctaRoute: getAutomationWorkflowsSettingsPath(),
  },
  {
    featureEnum: 'ConversationalAnalytics',
    titleKey: 'conversationalAnalyticsTitle',
    descriptionKey: 'conversationalAnalyticsDescription',
    confirmationTextKey: 'conversationalAnalyticsConfirmationText',
    requiresApproval: false,
    optionalCategory: LABS_CATEGORIES.ANALYTICS,
    ctaButtonTitleKey: 'conversationalAnalyticsCtaButtonTitle',
    ctaRoute: '/dashboard/conversational-analytics',
  },
  {
    featureEnum: 'OrderDetailsCustomLayout',
    titleKey: 'orderDetailsCustomLayoutTitle',
    descriptionKey: 'orderDetailsCustomLayoutDescription',
    confirmationTextKey: 'orderDetailsCustomLayoutConfirmationText',
    requiresApproval: false,
    optionalCategory: LABS_CATEGORIES.ORDERS,
    ctaButtonTitleKey: 'orderDetailsCustomLayoutCtaButtonTitle',
    ctaRoute: '/orders/awaiting-shipment',
  },
  {
    featureEnum: PackingRecommendations,
    titleKey: 'packingRecommendationsTitle',
    descriptionKey: 'packingRecommendationsDescription',
    confirmationTextKey: 'packingRecommendationsConfirmationText',
    requiresApproval: false,
    optionalCategory: LABS_CATEGORIES.AUTOMATION,
    ctaButtonTitleKey: 'packingRecommendationsCtaButtonTitle',
    ctaRoute: '/orders/awaiting-shipment',
  },
  {
    featureEnum: LossPrevention,
    titleKey: 'lossPreventionTitle',
    descriptionKey: 'lossPreventionDescription',
    confirmationTextKey: 'lossPreventionConfirmationText',
    requiresApproval: false,
    optionalCategory: LABS_CATEGORIES.AUTOMATION,
    ctaButtonTitleKey: 'lossPreventionCtaButtonTitle',
    ctaRoute: '/settings/loss-prevention',
  },
];

const processFeatures = (features) => {
  return features.map((feature) => ({
    id: feature.featureEnum,
    titleKey: feature.titleKey,
    descriptionKey: feature.descriptionKey,
    confirmationTextKey: feature.confirmationTextKey,
    requiresApproval: feature.requiresApproval,
    category: feature.optionalCategory,
    betaFeatureType: feature.featureType || FEATURE_RELEASE_TYPE.EARLY_ACCESS,
    ctaButtonTitleKey: feature.ctaButtonTitleKey,
    ctaRoute: feature.ctaRoute,
  }));
};

export const LABS_FEATURES = processFeatures(FEATURES);
